export default __webpack_public_path__ + "static/media/loc-arte-5.d0d4396c.webp";